import React, { useContext, useEffect } from 'react';
import { Toast, Variant } from '@leafygreen-ui/toast';

import { SnippetsContext } from 'baas-ui/common/context/SnippetsContext';

export const TestSelector = {
  InsertedSnippet: 'inserted-snippet-toast',
};

export const InsertedSnippetToast: React.FC = () => {
  const { inserted, setInserted } = useContext(SnippetsContext);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setInserted(false);
    }, 3000); // using 3 seconds based on design feedback

    return () => clearTimeout(timeoutId);
  }, [inserted]);

  return (
    <Toast
      data-testid={TestSelector.InsertedSnippet}
      open={inserted}
      variant={Variant.Success}
      title="Code snippet was successfully inserted."
    />
  );
};
